<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Automação - Enviar Whatsapp</v-toolbar-title>
      </v-toolbar>
      <v-row class="px-4">
        <v-col md="6">
          <p class="font-weight-bold">Dados para envio</p>
          <v-row>
            <v-col cols="12">
              <v-select
                label="Template"
                v-model="templateID"
                :items="templateOptions"
                outlined dense hide-details="auto"
              ></v-select>
            </v-col>
            <template v-if="templateID && templates[templateID] && templates[templateID].params && templates[templateID].params.length > 0">
              <v-col v-for="(param, index) in templates[templateID].params" :key="index" cols="12">
                <v-text-field
                  :label="param.label || `Parametro ${index + 1}`"
                  v-model="params[index]"
                  :placeholder="param.placeholder || undefined"
                  :prefix="param.prefix || undefined"
                  :hint="param.hint || undefined"
                  type="text"
                  outlined dense hide-details="auto"
                ></v-text-field>
              </v-col>
            </template>
          </v-row>
          <p class="font-weight-bold pt-6">Participantes</p>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Usuários separado por ponto-e-virgula: telefone|nome; telefone2|nome2"
                v-model="destinations"
                outlined dense
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6">
          <div
            v-if="example"
            class="px-4 pb-4 rounded-borders blue-grey lighten-5"
            style="white-space: pre-line"
            v-html="example"
          />
          <div class="row items-center mt-4">
            <div class="col title">Usuários</div>
            <div class="col-auto">
              <v-btn color="success" :disabled="sending" :loading="sending" @click="sendMessages()">
                Enviar
              </v-btn>
            </div>
          </div>
          <v-data-table
            dense
            :headers="headers"
            :items="items"
            :disable-pagination="true"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      sending: false,
      templateID: 'db229c9e-3e26-4329-aa94-197cd4b5455f',
      params: [
        '',
        '',
        '',
        '',
        '',
        '',
        ''
      ],
      destinations: '',
      items: [],
      headers: [
        {
          text: 'Nome',
          value: 'name',
          sortable: false
        },
        {
          text: 'Telefone',
          value: 'phone',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false
        }
      ],
      templates: {
        'db229c9e-3e26-4329-aa94-197cd4b5455f': {
          label: 'Cobrança - lembrete de faturas em aberto',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10',
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Texto complementar',
              placeholder: 'Ele vem logo após "(...) em aberto. "'
            }
          ],
          destinationsFormat: 'telefone|nome; telefone2|nome2',
          example: `
            <b>{{params[0]}}</b>
            Olá {{params[1]}}!

            A Heppi está entrando em contato com você, para te lembrar que algumas mensalidades estão em aberto. {{params[2]}}

            Você pode acessar suas pendências através do nosso app ou do nosso site informando seu CPF.

            Você também pode contar com a ajuda do nosso suporte para ter acesso às suas faturas ou negociar o pagamento respondendo a essa mensagem. Vamos conversar?

            [Baixar o app - https://heppi.com.br/baixe-o-app]
            [Acessar fatura pelo CPF - https://fatura.heppi.io/]
          `
        },
        '5258c890-8ff7-4104-9f47-5b315ae98462': {
          label: 'Assinatura do estatuto',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10',
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Texto complementar',
              placeholder: 'Ele vem logo após "(...) informar que: "'
            },
            {
              label: 'ID Link Assinatura',
              prefix: 'https://assina.ae/',
              value: '[item3]'
            }
          ],
          destinationsFormat: 'telefone|nome|idLinkAssinatura; telefone2|nome2|idLinkAssinatura',
          example: `
            <b>{{params[0]}}</b>
            Olá {{params[1]}}!

            Estamos entrando em contato para informar que: {{params[2]}}

            [Assinar o estatuto - https://assina.ae/{{params[3]}}]
          `
        },
        '482a0e19-ed2a-40ba-a2b7-ad034b0571e4': {
          label: 'Aviso da comissão (genérico)',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10',
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Texto complementar',
              placeholder: 'Ele vem logo após "(...) da sua comissão: "'
            }
          ],
          destinationsFormat: 'telefone|nome; telefone2|nome2',
          example: `
            <b>{{params[0]}}</b>
            Olá {{params[1]}},

            Temos um comunicado da sua comissão:

            {{params[2]}}
          `
        },
        // '4e7dc09a-f229-48e8-84c6-700e43330d60': {
        //   label: 'Onboarding',
        //   params: [
        //     {
        //       label: 'Nome do formando',
        //       value: '[item2]'
        //     },
        //     {
        //       label: 'Texto complementar',
        //       placeholder: 'Ele vem nesse espaço: "(...) hora de começar a ____ !"'
        //     }
        //   ],
        //   destinationsFormat: 'telefone|nome; telefone2|nome2',
        //   example: `
        //     Olá, {{params[0]}}!

        //     Chegou a hora de começar {{params[1]}}!

        //     A Heppi já está pronta para você iniciar e te ajudar nesse processo.
        //     Responda essa mensagem e dê início ao seu atendimento no WhatsApp para realizar o seu cadastro e começar agora mesmo!

        //     <b>Vamos juntos fazer esse momento acontecer.</b> ✨
        //   `
        // },
        '1ff0211e-2865-454c-957e-0144c6b4d2dd': {
          label: 'Informativo sobre o congelamento',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Artigo do estatuto',
              value: 'art. 16 do Estatuto da Turma'
            },
            {
              label: 'Tempo de inadimplência',
              value: '03 (três) meses ou mais'
            },
            {
              label: 'Reajuste',
              value: '3% até dez/2026 e 5% a partir de jan/2027'
            }
          ],
          destinationsFormat: 'telefone|nome; telefone2|nome2',
          example: `
            <b>{{params[0]}}</b>

            Olá, {{params[1]}}!

            Conforme o {{params[2]}}, a inadimplência por {{params[3]}} pode gerar congelamento automático, após tentativa de contato sem retorno.

            Se houver congelamento, para retornar é necessário entrar em contato conosco e regularizar o débito (quitação ou renegociação). O retorno terá reajuste de {{params[4]}}.

            Importante: os valores em aberto continuam devidos independentemente do retorno, não havendo cancelamento da dívida, podendo haver cobrança extrajudicial.

            Em caso de dúvidas ou para iniciar a regularização, é só responder por aqui.
          `
        },
        '2ef56622-8938-4c01-a62c-fb56e30cb6ba': {
          label: 'Bem-vindo - importação',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Observação',
              value: 'Obs: '
            },
            {
              label: 'ID Link Assinatura',
              prefix: 'https://assina.ae/',
              value: '[item3]'
            }
          ],
          destinationsFormat: 'telefone|nome|idestatuto; telefone2|nome2|idestatuto2',
          example: `
            <b>{{params[0]}}</b>

            Olá, {{params[1]}}!

            A gestão financeira da sua formatura agora é feita pela Heppi!

            Seus dados foram importados e sua primeira fatura já está disponível no nosso app. Para acessar, faça o login utilizando o seu número de telefone.

            Lembre-se também de assinar o estatuto da turma para garantir a proteção de todos.

            Aproveite para salvar nosso contato! Caso precise de ajuda, nosso suporte atende de segunda a sexta, das 9h às 18h.

            <i>{{params[2]}}</i>

            <b>Bem-vindo à Heppi!</b>

            [Assinar o estatuto - https://assina.ae/{{params[3]}}]
            [Acesse o app - https://heppi.com.br/baixe-o-app]
          `
        },
        'e338278a-c130-4c77-82b2-38bfe006b33f': {
          label: 'Bem-vindo especial - importação sem fatura',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Observação',
              value: 'Obs: '
            },
            {
              label: 'ID Link Assinatura',
              prefix: 'https://assina.ae/',
              value: '[item3]'
            }
          ],
          destinationsFormat: 'telefone|nome|idestatuto; telefone2|nome2|idestatuto2',
          example: `
            <b>{{params[0]}}</b>

            Olá, {{params[1]}}!

            A gestão financeira da sua formatura agora é feita pela Heppi!

            Seus dados foram cadastrados e você só precisa assinar o estatuto abaixo e, em até 24h, sua primeira fatura estará disponível. Para acessar, utilize o app da Heppi, entrando com o número de telefone informado.

            Aproveita e salva esse nosso número. Caso precise de alguma coisa é só chamar. Nosso suporte fica disponível de segunda à sexta, das 9h às 18h.

            <i>{{params[2]}}</i>

            <b>Bem-vindo à Heppi!</b>

            [Assinar o estatuto - https://assina.ae/{{params[3]}}]
            [Acesse o app - https://heppi.com.br/baixe-o-app]
          `
        },
        'a8530c6d-1e54-4ff7-9816-86d5d396ac91': {
          label: 'Bem-vindo - inicio do mês',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Mês',
              value: ''
            },
            {
              label: 'Dia do Vencimento',
              value: ''
            },
            {
              label: 'Observação',
              value: 'Obs: '
            },
            {
              label: 'ID Link Assinatura',
              prefix: 'https://assina.ae/',
              value: '[item3]'
            }
          ],
          destinationsFormat: 'telefone|nome|idestatuto; telefone2|nome2|idestatuto2',
          example: `
            <b>{{params[0]}}</b>

            Olá, {{params[1]}}!

            A gestão financeira da sua formatura agora é feita pela Heppi!

            Seus dados foram cadastrados e você só precisa assinar o estatuto abaixo para iniciar sua arrecadação. A fatura de {{params[2]}} ficará disponível no dia 5 com o vencimento no dia {{params[3]}}. Para acessar, utilize o app da Heppi, entrando com o número de telefone informado.

            Aproveita e salva esse nosso número. Caso precise de alguma coisa é só chamar. Nosso suporte fica disponível de segunda à sexta, das 9h às 18h.

            <i>{{params[4]}}</i>

            <b>Bem-vindo à Heppi!</b>

            [Assinar o estatuto - https://assina.ae/{{params[5]}}]
            [Acesse o app - https://heppi.com.br/baixe-o-app]
          `
        },
        'f09718d9-83e7-49a6-9603-addaec683d0b': {
          label: 'Chamado para participar',
          params: [
            {
              label: 'Nome da turma',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Nome do formando',
              value: '[item2]'
            },
            {
              label: 'Nome da turma (dentro do texto)',
              placeholder: 'Colocar igual ao nome da turma do suporte. Ex: Medicina Nassau 10'
            },
            {
              label: 'Informação adicional',
              value: ' '
            },
            {
              label: 'Prazo',
              value: ''
            },
            {
              label: 'Ponto 1',
              value: '- LOTE PROMOCIONAL com uma economia de R$ 0,00 no total de pacote'
            },
            {
              label: 'Ponto 2',
              value: '- Dividir em até 0x de R$ 0,00'
            },
            {
              label: 'Ponto 3',
              value: '- E você ainda pode pagar no boleto ou cartão de crédito'
            }
          ],
          destinationsFormat: 'telefone|nome; telefone2|nome2',
          example: `
            <b>{{params[0]}}</b>

            Oi, {{params[1]}}! Tudo bem?

            A arrecadação da turma <b>{{params[2]}}</b> já começou junto com a <b>Heppi</b>! {{params[3]}}

            <b>Começando cedo</b>, a turma ganha <b>mais tempo para arrecadar</b> e fazer o valor render, fortalecendo o orçamento e contribuindo para uma <b>estrutura ainda melhor para a formatura</b>.

            Aderindo até {{params[4]}}, você garante

            {{params[5]}}
            {{params[6]}}
            {{params[7]}}

            <b>Não deixe esse oportunidade passar!</b>

            Basta responder essa mensagem dizendo que quer participar junto com seu nome que te enviamos os próximos passos!
          `
        }
      }
    }
  },
  computed: {
    templateOptions () {
      const templateOptions = []
      for (const key in this.templates) {
        const template = this.templates[key]
        templateOptions.push({ text: template.label, value: key })
      }
      return templateOptions
    },
    example () {
      if (this.templateID && this.templates[this.templateID] && this.templates[this.templateID].example) {
        let example = this.templates[this.templateID].example
        const params = this.templates[this.templateID].params
        for (const index in this.params) {
          let newValue = this.params[index]
          if (this.items && this.items[0] && newValue) {
            for (let i = 1; i <= Object.keys(this.items[0]).length - 3; i++) {
              if (this.items[0]['item' + i]) newValue = newValue.replace('[item' + i + ']', this.items[0]['item' + i])
            }
          }
          example = example.replace(`{{params[${index}]}}`, newValue || `[${(params[index] && params[index].label) || ' '}]`)
        }
        return example
      }
      return ''
    }
  },
  watch: {
    destinations () {
      this.generateItems()
    },
    templateID (val) {
      this.setTemplateDefaults()
    }
  },
  methods: {
    ...mapActions(['sendWhatsapp']),
    setTemplateDefaults () {
      if (this.templateID && this.templates[this.templateID]) {
        if (this.templates[this.templateID].params && this.templates[this.templateID].params.length > 0) {
          for (const p in this.templates[this.templateID].params) {
            const param = this.templates[this.templateID].params[p]
            if (param.value) this.$set(this.params, p, param.value)
          }
        }
      }
    },
    generateItems () {
      if (this.destinations) {
        this.items = []
        const destArray = this.destinations.split(';')
        for (let i = 0; i < destArray.length; i++) {
          if (destArray[i].trim()) {
            const itemData = destArray[i].split('|')
            const item = {
              phone: itemData[0].trim(),
              name: (itemData[1]) ? itemData[1].trim() : '',
              status: 'Aguardando'
            }
            for (const j in itemData) {
              item['item' + (parseInt(j) + 1)] = itemData[j]
            }
            this.items.push(item)
          }
        }
      }
    },
    async sendMessages () {
      if (this.destinations && this.items && this.templateID && this.templates[this.templateID]) {
        this.sending = true
        for (let i = 0; i < this.items.length; i++) {
          const index = i
          const item = this.items[i]
          const params = []

          for (const pIndex in this.templates[this.templateID].params) {
            let param = this.params[pIndex]
            if (param) {
              if (item.name) param = param.replace('[name]', item.name)
              for (let i = 1; i <= Object.keys(item).length - 3; i++) {
                if (item['item' + i]) param = param.replace('[item' + i + ']', item['item' + i])
              }
              params.push(param)
            } else {
              params.push(' ')
            }
          }

          const data = {
            destination: '55' + item.phone,
            template: this.templateID,
            params
          }

          await this.sendWhatsapp(data)
            .then(() => { this.items[index].status = 'ok' })
            .catch(() => { this.items[index].status = 'fail' })

          this.sending = false
        }
      }
    }
  },
  mounted () {
    this.setTemplateDefaults()
  }
}
</script>
